import { useState } from "react";
import { Divider, FloatingIndicator, Paper, Tabs } from "@mantine/core";
import classes from "./tabs.module.scss";
import ActionsSwitches from "../actionsSwitches/ActionsSwitches";

function RolesTabs() {
  const [rootRef, setRootRef] = useState(null);
  const [value, setValue] = useState("1");
  const [controlsRefs, setControlsRefs] = useState({});
  const setControlRef = (val) => (node) => {
    controlsRefs[val] = node;
    setControlsRefs(controlsRefs);
  };

  return (
    <Paper bg="secondary.0" p="md" radius={0}>
      {/* keepMounted prevents pre-rendering of inactive tab panels */}
      <Tabs
        variant="none"
        keepMounted={false}
        value={value}
        onChange={setValue}
      >
        <Tabs.List ref={setRootRef} className={classes.list}>
          <Tabs.Tab value="1" ref={setControlRef("1")} className={classes.tab}>
            Admin (IT admin)
          </Tabs.Tab>
          <Tabs.Tab value="2" ref={setControlRef("2")} className={classes.tab}>
            Backoffice specialist 1st level (AML coordinator)
          </Tabs.Tab>
          <Tabs.Tab value="3" ref={setControlRef("3")} className={classes.tab}>
            Backoffice specialist 2nd level (AML manager)
          </Tabs.Tab>
          <Tabs.Tab value="4" ref={setControlRef("4")} className={classes.tab}>
            Auditor
          </Tabs.Tab>
          <Tabs.Tab value="5" ref={setControlRef("5")} className={classes.tab}>
            Customer Support
          </Tabs.Tab>

          <FloatingIndicator
            target={value ? controlsRefs[value] : null}
            parent={rootRef}
            className={classes.indicator}
          />
        </Tabs.List>
        <Divider size="md" color="secondary.1" />
        <Tabs.Panel value="1">
          <ActionsSwitches role={"ADMIN"} />
        </Tabs.Panel>
        <Tabs.Panel value="2">
          <ActionsSwitches role={"AML_CORDINATOR"} />
        </Tabs.Panel>
        <Tabs.Panel value="3">
          <ActionsSwitches role={"AML_MANAGER"} />
        </Tabs.Panel>
        <Tabs.Panel value="4">
          <ActionsSwitches role={"AUDITOR"} />
        </Tabs.Panel>
        <Tabs.Panel value="5">
          <ActionsSwitches role={"CUSTOMER_SUPPORT"} />
        </Tabs.Panel>
      </Tabs>
    </Paper>
  );
}

export default RolesTabs;
